<banner-app
  [Fixtop]="''"
  [retroSelected]="false"
  [infoDueno]="true"
  [showPromo]="true"
></banner-app>

<div class="py-lg-5 feedback-container">
  <div class="row justify-content-center me-0">
    <div
      class="col-12 col-md-8 col-lg-6 d-flex flex-column align-items-center text-center"
    >
      <h2 class="feedback-title mb-lg-0 mb-4">¡Ya tenemos tus datos!</h2>
      <p class="feedback-subtitle mb-lg-0 mb-4">
        Nos pondremos en contacto contigo para continuar con el proceso.
      </p>

      <img
        class="feedback-image"
        ngSrc="./assets/img/FeedBackManos.png"
        width="500"
        height="320"
        priority
        alt="Ilustración de dos manos estrechándose en señal de acuerdo."
      />

      <button
        type="button"
        class="btn btn-primary btn-lg rounded-pill sura-feedback-btn mt-lg-0 mt-3 mb-5"
        (click)="volverAlInicio()"
      >
        Volver al inicio
      </button>
    </div>
  </div>
</div>

<app-footer-app></app-footer-app>
